import { apiClient } from '../config/ApiClient';
import type { UserDTO } from '../dto/UserDTO';
import { UpdatePasswordDTO } from '../dto/RegisterDTO';

export const fetchUser = (userName: string) =>
  apiClient.get<UserDTO>(`/user/${userName}`);

/** Matches @PutMapping("/") in UserController */
export const updateUser = (dto: UserDTO) => apiClient.put<void>('/user/', dto);

/** Matches @PostMapping("/password") in UserController */
export const updatePassword = (dto: UpdatePasswordDTO) =>
  apiClient.post<void>('/user/password', dto);

export const deleteUser = (userName: string) =>
  apiClient.delete<void>(`/user/${userName}`);
